import i18n from "@/i18n";
import MobileDetect from "mobile-detect";
import getDataByDate from "@/utils/getDataByDate.ts";

const md = new MobileDetect(window.navigator.userAgent);
const isMobile = !!md.mobile();

const { VUE_APP_HOMEPAGE_NOTICES, VUE_APP_WHALE_HOMEPAGE } = process.env;

export const whale_lab = "https://forum.whale.naver.com/forum/43/";
export const notice = "https://notice.naver.com/notices";
export const homepage_notices = `${VUE_APP_HOMEPAGE_NOTICES}/notices?categoryName=developers`;

export const getTerms = locale =>
    getDataByDate({
        oldData: "/terms",
        newData: `https://whale.naver.com/legal/whalespace-terms-developers/${
            locale === "ko" ? "ko" : "en"
        }`,
        newStartDate: "2023-05-01 00:00"
    });

export const getPrivacy = locale =>
    `https://policies.whale.naver.com/${
        locale === "ko" ? "ko" : "en"
    }/whalespace-privacy`;
export const getPrivacyWhale = locale =>
    `https://whale.naver.com/legal/privacy/${locale === "ko" ? "ko" : "en"}`;
export const help_naver = isMobile
    ? "https://m.help.naver.com/support/service/main.help?serviceNo=17587"
    : "https://help.naver.com/support/service/main.nhn?serviceNo=17568";
export const getCopyright = locale =>
    `https://www.navercorp.com/${locale === "ko" ? "ko" : "en"}`;

export const getFooterLinks = (locale = i18n.locale) => ({
    terms: getTerms(locale),
    privacy: getPrivacy(locale),
    privacy_whale: getPrivacyWhale(locale),
    help_naver,
    copyright: getCopyright(locale)
});

export const getWhaleDownload = locale =>
    `https://whale.naver.com/${locale === "ko" ? "ko" : "en"}`;
export const homepage_sample = "https://whalespace.io/services/space_admin";
export const homepage_service = "https://whalespace.io/services";

export const getLoginURL = redirect =>
    `/api/v1/auth/login/naver?redirect_url=${redirect || location.origin}`;

export const naver_mypage = "https://nid.naver.com/user2/help/myInfo";
export const naver_external_auth =
    "https://nid.naver.com/user2/help/externalAuth?lang=ko_KR";

export const notice_update_terms = `${notice}/whalespace/9754?sectionId=170&lang=ko`;

export const termsContentsUrl = `${VUE_APP_WHALE_HOMEPAGE}/legal/whalespace-terms-developers/${i18n.locale}/?contents=true`;
